export default __webpack_public_path__ + "static/media/Schnecke-mit-Blume.1bb402e6.png";